import { useQuery } from "@tanstack/react-query";
import { Button, Space } from "antd";
import { Link } from "react-router-dom";
import { fetchImageCaptureAccounts } from "./../../../../lib/api/resources/imageCaptureAccounts";
import { imageCaptureAccountColumns } from "./lib/constants/imageCaptureAccountColumns";
import { Table } from "@/components/v2";
import { PlusOutlined } from "@ant-design/icons";

export const ImageCaptureAccountList = () => {
  const accountsQuery = useQuery({
    queryKey: ["imageCaptureAccounts"],
    queryFn: fetchImageCaptureAccounts,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/image-captures/accounts/create">
          <Button icon={<PlusOutlined />}>Nieuw account</Button>
        </Link>
      </Space>
      <Table
        columns={imageCaptureAccountColumns}
        dataSource={accountsQuery?.data}
        loading={accountsQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
